import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { useRetroMode } from '../context/RetroModeContext'

// Nudges an element toward the cursor while hovered, snapping back on leave.
export const useMagnetic = ({ strength = 0.35 } = {}) => {
  const ref = useRef(null)
  const { retroMode } = useRetroMode()

  useEffect(() => {
    const el = ref.current
    if (!el) return undefined
    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches
    if (retroMode || reduceMotion) return undefined

    const moveX = gsap.quickTo(el, 'x', { duration: 0.3, ease: 'power2.out' })
    const moveY = gsap.quickTo(el, 'y', { duration: 0.3, ease: 'power2.out' })

    const handleMove = (event) => {
      const rect = el.getBoundingClientRect()
      const relX = event.clientX - (rect.left + rect.width / 2)
      const relY = event.clientY - (rect.top + rect.height / 2)
      moveX(relX * strength)
      moveY(relY * strength)
    }

    const handleLeave = () => {
      moveX(0)
      moveY(0)
    }

    el.addEventListener('mousemove', handleMove)
    el.addEventListener('mouseleave', handleLeave)
    return () => {
      el.removeEventListener('mousemove', handleMove)
      el.removeEventListener('mouseleave', handleLeave)
      gsap.set(el, { clearProps: 'transform' })
    }
  }, [retroMode, strength])

  return ref
}
